import url from './url';

const api = {
  sentences: url.baseUrl2 + '/sentences',  //这只是一个测试的接口地址

  // 本地流程包
  addLocalProcess: url.baseUrl1 + '/api/merak/uploader', //新增本地流程包
}


export default api;